/** Product permission key for AI Voice Agent */
export const AI_VOICE_AGENT_MODULE = 'ai_voice_agent';

/** Rentsync 2.0 page where the AI leasing agent is configured. The same on every environment. */
export const BSTK_LEASE_AGENT_SETTINGS_URL = 'https://app.buildingstack.com/agents/leaseagent';
